export default __webpack_public_path__ + "static/media/AnkushSharma.f8c77c5f.png";